/**
 * Connection status of an integration
 */
export enum ProviderConnectionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
